import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import FiChevronLeftImg from '../../assets/images/fi_chevron_left.png';
import FiChevronRightImg from '../../assets/images/fi_chevron_right.png';
import FiSearch from '../../assets/images/fi_search.png';
import BackArrow from '../../assets/images/Frame_18177.png';
import axiosInstance from '../../api/axiosInstance';
import axios from 'axios';
import StepOne from './steps/StepOne';
import InactivityTimer from '../../components/InactivityTimer';
import { use } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useSelector } from 'react-redux';

const BookAppointment = () => {

    const location = useLocation();
    const patientId = location.state?.patientId;

    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [selectedSlot, setSelectedSlot] = useState('');
    const [selectedSlotData, setSelectedSlotData] = useState(null); // Store full slot object
    const [filteredDoctors, setFilteredDoctors] = useState([]);
    const [isDoctorSelected, setIsDoctorSelected] = useState(false);

    // API states
    const [allDepartments, setAllDepartments] = useState([]);
    const [filteredDepartments, setFilteredDepartments] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [departmentDoctors, setDepartmentDoctors] = useState({});
    const [loading, setLoading] = useState(true);
    const [slotsLoading, setSlotsLoading] = useState(false);
    const [doctorsLoading, setDoctorsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [availableSlots, setAvailableSlots] = useState([]);
    const [morningSlots, setMorningSlots] = useState([]);
    const [afternoonSlots, setAfternoonSlots] = useState([]);
    const [eveningSlots, setEveningSlots] = useState([]);
    const [nightSlots, setNightSlots] = useState([]);
    const [patientData, setPatientData] = useState(null);
    const [showIPStatusDialog, setShowIPStatusDialog] = useState(false);
    const [isIPPatient, setIsIPPatient] = useState(false);

    console.log(patientData);
    const token = useSelector((state) => state.auth.kiosk_token);

    const fetchPatientData = async () => {
        try {
            const decodedToken = jwtDecode(token);
            const response = await axios.get(`${process.env.REACT_APP_KIOSK_OPS_URL}/patient/registeredPatientDetails?input=${encodeURIComponent(decodedToken.mrno)}`, {

                // const response = await axios.get(`${process.env.REACT_APP_KIOSK_OPS_URL}/patient/registeredPatientDetails?input=KIMS102312190198`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1')}`,
                },
            });
            const visitDetails = response.data.data[0].visitDetails;
            setPatientData(visitDetails);

            // Check if patient status starts with 'IP' and visitStatus is 'open'
            if (visitDetails && visitDetails.patVisitStatus && visitDetails.patVisitStatus.startsWith('IP') && visitDetails.visitStatus === 'open') {
                setIsIPPatient(true);
                setShowIPStatusDialog(true);
            }
        } catch (err) {
            console.error("Error fetching patient data:", err);
        }
    };

    useEffect(() => {
        fetchPatientData();
    }, []);

    // Fetch available time slots for selected doctor
    const fetchAvailableSlots = async (deptId, employeeId, selectedDate) => {
        try {
            setSlotsLoading(true);
            const date = selectedDate || new Date();
            const dateStr = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}`;

            const response = await axios.get(
                `${process.env.REACT_APP_KIOSK_OPS_URL}/kiosk/availableDoctorSlots?deptId=${deptId}&employeeId=${employeeId}&date=${dateStr}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1')}`,
                    },
                }
            );

            console.log('Available slots response:', response.data);

            if (response.data && (response.data.status === 'success' || response.data.status === 'Success') && response.data.data) {
                const slots = response.data.data;
                setAvailableSlots(slots);

                // Categorize slots into morning, afternoon, evening
                categorizeSlots(slots);
            } else {
                setAvailableSlots([]);
                setMorningSlots([]);
                setAfternoonSlots([]);
                setEveningSlots([]);
                setNightSlots([]);
            }
            setSlotsLoading(false);
        } catch (error) {
            console.error('Error fetching available slots:', error);
            setSlotsLoading(false);
            setAvailableSlots([]);
            setMorningSlots([]);
            setAfternoonSlots([]);
            setEveningSlots([]);
            setNightSlots([]);
        }
    };

    // Categorize slots based on time
    const categorizeSlots = (slots) => {
        const morning = [];
        const afternoon = [];
        const evening = [];
        // BUG 4 FIX: midnight-to-dawn slots (00:00–05:59) must NOT fall
        // into the evening bucket — they are a separate night session.
        const night = [];

        slots.forEach(slot => {
            // Extract hour from slotTimeStr (format like "13:30 PM" or "09:05 AM")
            const timeStr = slot.slotTimeStr || '';
            const hourMatch = timeStr.match(/(\d{1,2}):(\d{2})/);

            if (hourMatch) {
                const hour = parseInt(hourMatch[1], 10);

                // Categorize by 24-hour format
                if (hour >= 0 && hour < 6) {
                    // midnight – 05:59 → Night
                    night.push(slot);
                } else if (hour >= 6 && hour < 12) {
                    morning.push(slot);
                } else if (hour >= 12 && hour < 17) {
                    afternoon.push(slot);
                } else {
                    // 17:00 – 23:59 → Evening
                    evening.push(slot);
                }
            }
        });

        setMorningSlots(morning);
        setAfternoonSlots(afternoon);
        setEveningSlots(evening);
        setNightSlots(night);
    };

    const slots = [
        { time: "09:00 - 09:15", status: "Available" },
        { time: "09:15 - 09:30", status: "Available" },
        { time: "09:30 - 09:45", status: "Available" },
        { time: "09:45 - 10:00", status: "Available" },
        { time: "10:00 - 10:15", status: "Available" },
        { time: "10:15 - 10:30", status: "Booked" },
        { time: "10:30 - 10:45", status: "Booked" },
        { time: "10:45 - 11:00", status: "Available" },
        { time: "11:00 - 11:15", status: "Available" },
        { time: "11:15 - 11:30", status: "Booked" },
        { time: "11:30 - 11:45", status: "Available" },
        { time: "11:45 - 12:00", status: "Booked" },
        { time: "12:00 - 12:15", status: "Available" },
    ];

    // Fetch all departments and their doctors
    const getAllDepartments = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_KIOSK_OPS_URL}/department/deptList?branchId=${localStorage.getItem('site_id')}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1')}`,
                },
            });
            const departments = response.data.data;
            setAllDepartments(departments);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching departments:', error);
            setLoading(false);
        }
    };

    const getDepartmentDoctors = async (departmentId, date = selectedDate) => {
        try {
            const formattedDate = formatDate(date);
            const response = await axios.get(`${process.env.REACT_APP_KIOSK_OPS_URL}/department/deptDocList?deptId=${departmentId}&date=${formattedDate}&siteId=${localStorage.getItem('site_id')}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1')}`,
                },
            });
            return response.data.data || [];
        } catch (error) {
            console.error('Error fetching doctors for department:', error);
            return [];
        }
    };

    // Date state and handlers
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const [selectedDate, setSelectedDate] = useState(tomorrow);
    const [formData, setFormData] = useState({
        patientType: '',
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        getAllDepartments();
    }, []);

    // Filter departments based on search query
    useEffect(() => {
        if (searchQuery.trim() === '') {
            setFilteredDepartments(allDepartments);
        } else {
            const filtered = allDepartments.filter(dept =>
                (dept.departmentName || dept.deptName || '')
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase())
            );
            setFilteredDepartments(filtered);
        }
    }, [searchQuery, allDepartments]);

    // Refetch doctors and slots when date changes
    useEffect(() => {
        if (selectedDepartment) {
            // Refetch doctors for the selected date
            const fetchDoctorsForDate = async () => {
                setDoctorsLoading(true);
                try {
                    const doctors = await getDepartmentDoctors(selectedDepartment.departmentId, selectedDate);
                    setFilteredDoctors(doctors);

                    // Reset doctor and slot selection when date changes
                    setSelectedDoctor(null);
                    setIsDoctorSelected(false);
                    setSelectedSlot('');
                    setAvailableSlots([]);
                    setMorningSlots([]);
                    setAfternoonSlots([]);
                    setEveningSlots([]);
                    setNightSlots([]);
                } catch (error) {
                    console.error('Error loading doctors for new date:', error);
                    setFilteredDoctors([]);
                } finally {
                    setDoctorsLoading(false);
                }
            };

            fetchDoctorsForDate();
        }
    }, [selectedDate]);

    const handleDepartmentChange = async (department) => {
        setSelectedDepartment(department);
        setSelectedDoctor(null); // Reset selected doctor when department changes
        setIsDoctorSelected(false); // Hide slots until doctor is selected
        setFilteredDoctors([]); // Clear previous doctors
        setSelectedSlot(''); // Clear selected slot

        setErrors((prevErrors) => ({
            ...prevErrors,
            department: ''  // Clear department error when selected
        }));

        // Fetch doctors for the selected department
        setDoctorsLoading(true);
        try {
            const doctors = await getDepartmentDoctors(department.departmentId, selectedDate);
            setFilteredDoctors(doctors);

            // Store in departmentDoctors cache for future use
            setDepartmentDoctors(prev => ({
                ...prev,
                [department.departmentId]: doctors
            }));
        } catch (error) {
            console.error('Error loading doctors:', error);
            setFilteredDoctors([]);
        } finally {
            setDoctorsLoading(false);
        }
    };

    const handleDoctorChange = (doctor) => {
        setSelectedDoctor(doctor);
        setIsDoctorSelected(true); // Show slots after selecting doctor
        setSelectedSlot(''); // Reset slot when doctor changes

        setErrors((prevErrors) => ({
            ...prevErrors,
            doctor: ''  // Clear doctor error when selected
        }));

        // Fetch available slots for the selected doctor
        if (selectedDepartment && doctor) {
            fetchAvailableSlots(
                selectedDepartment.departmentId,
                doctor.empId || doctor.consultantId,
                selectedDate
            );
        }
    };

    const handleSlotChange = (e) => {
        const slotTimeStr = e.target.value;
        setSelectedSlot(slotTimeStr);

        // Find the full slot object from availableSlots
        const slotObject = availableSlots.find(slot => slot.slotTimeStr === slotTimeStr);
        setSelectedSlotData(slotObject);

        setErrors((prevErrors) => ({
            ...prevErrors,
            slot: ''  // Clear slot error when selected
        }));
    };

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Prevent booking if patient is IP
        if (isIPPatient) {
            setShowIPStatusDialog(true);
            return;
        }

        if (!validateForm()) return;

        setIsSubmitting(true);

        // Fetch patient details for Razorpay prefill
        let patientMobile = '';
        let patientEmail = '';
        let patientName = '';

        try {
            const decodedToken = jwtDecode(token);
            const response = await axios.get(`${process.env.REACT_APP_KIOSK_OPS_URL}/patient/registeredPatientDetails?input=${encodeURIComponent(decodedToken.mrno)}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1')}`,
                },
            });

            if (response.data && response.data.data && response.data.data.length > 0) {
                const patient = response.data.data[0];
                patientMobile = patient.contactNo || '';
                patientEmail = patient.email || '';

                // Format full name
                const nameParts = [
                    patient.prefix,
                    patient.firstName,
                    patient.middleName,
                    patient.lastName
                ].filter(part => part && part.trim() !== '');
                patientName = nameParts.join(' ');
            }
        } catch (error) {
            console.error('Error fetching patient details:', error);
            // Continue with booking even if patient details fetch fails
        }

        // Prepare appointment data
        const appointmentData = {
            patientId: patientId,
            departmentId: selectedDepartment.departmentId,
            departmentName: selectedDepartment.departmentName || selectedDepartment.deptName,
            doctorId: selectedDoctor.empId || selectedDoctor.consultantId,
            doctorName: selectedDoctor.empName || selectedDoctor.consultantName,
            empNo: selectedDoctor.empNo,
            serviceCode: selectedDoctor.serviceCode,
            serviceId: selectedDoctor.serviceId,
            serviceName: selectedDoctor.serviceName,
            hospitalId: selectedDoctor.hospitalId,
            consultationFee: selectedDoctor.totalAmount,
            appointmentDate: formatDate(selectedDate),
            appointmentSlot: selectedSlot,
            weekDay: selectedDoctor.weekDay,
            dayName: selectedDoctor.dayName,
            unitId: selectedSlotData?.unit?.toString() || null, // Add unitId from selected slot
            // Add patient contact details for Razorpay prefill
            patientMobile: patientMobile,
            patientEmail: patientEmail,
            patientName: patientName
        };

        // Check if consultation fee is 0
        const feeAmount = parseFloat(selectedDoctor.totalAmount);

        if (feeAmount === 0) {
            // Skip payment gateway for zero-fee appointments
            try {
                const response = await axiosInstance.post('/api/patient/create-consultation-order', {
                    amount: 0,
                    appointmentData: appointmentData,
                    siteCode: localStorage.getItem('site_code') || null,
                    himsToken: localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1') || null, // HIMS token for server-side fee verification
                });

                if (response.data.success && response.data.freeConsultation) {
                    // Navigate to appointment success page
                    navigate(`/appointment-success?appointmentId=${response.data.appointmentId}&patientId=${response.data.patientId}&mrno=${response.data.mrno}&freeConsultation=true`);
                    return;
                }
            } catch (error) {
                console.error('Error booking free appointment:', error);
                alert('Failed to book appointment. Please try again.');
                setIsSubmitting(false);
                return;
            }
            setIsSubmitting(false);
            return;
        }

        // For non-zero fees, create the order and go straight to the payment gateway
        localStorage.setItem('appointmentData', JSON.stringify(appointmentData));

        try {
            const orderResponse = await axiosInstance.post('/api/patient/create-consultation-order', {
                amount: appointmentData.consultationFee,
                appointmentData: appointmentData,
                siteCode: localStorage.getItem('site_code') || null,
                himsToken: localStorage.getItem('token')?.replace(/^"(.*)"$/, '$1') || null, // HIMS token for server-side fee verification
            });

            const { razorpayOrderId, amount, currency, key } = orderResponse.data;

            const form = document.createElement('form');
            form.method = 'POST';
            form.action = 'https://api.razorpay.com/v1/checkout/embedded';

            const formFields = {
                key_id: key,
                amount: amount.toString(),
                currency: currency,
                name: "KIMS Hospital",
                description: `Consultation Fee - ${appointmentData.doctorName}`,
                image: "/logo.jpg",
                order_id: razorpayOrderId,
                callback_url: `${axiosInstance.defaults.baseURL}/api/patient/verify-payment`,
                cancel_url: `${axiosInstance.defaults.baseURL}/api/patient/cancel-payment`,
                notes: {
                    appointment_data: JSON.stringify(appointmentData),
                    payment_type: 'consultation'
                },
                prefill: {
                    name: appointmentData.patientName || '',
                    email: appointmentData.patientEmail || '',
                    contact: appointmentData.patientMobile || '',
                },
                theme: { color: "#0FA968" },
            };

            Object.keys(formFields).forEach((fieldKey) => {
                if (typeof formFields[fieldKey] === 'object') {
                    Object.keys(formFields[fieldKey]).forEach((subKey) => {
                        const input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = `${fieldKey}[${subKey}]`;
                        input.value = formFields[fieldKey][subKey];
                        form.appendChild(input);
                    });
                } else {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = fieldKey;
                    input.value = formFields[fieldKey];
                    form.appendChild(input);
                }
            });

            document.body.appendChild(form);
            form.submit();
        } catch (error) {
            console.error('Error creating order:', error);
            alert('Failed to initiate payment. Please try again.');
            setIsSubmitting(false);
        }
    }

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchQuery(value);
    }

    const isToday = selectedDate.toDateString() === today.toDateString();

    const handleNextDate = () => {
        const nextDate = new Date(selectedDate);
        nextDate.setDate(selectedDate.getDate() + 1);
        setSelectedDate(nextDate);
    };

    const handlePrevDate = () => {
        const prevDate = new Date(selectedDate);
        prevDate.setDate(selectedDate.getDate() - 1);

        // Don't allow going back to today or before
        if (prevDate > today) {
            setSelectedDate(prevDate);
        }
    };

    // Function to format date in dd-mm-yyyy
    const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const validateForm = () => {
        const formErrors = {};
        if (!selectedDepartment) formErrors.department = 'Department is required';
        if (!selectedDoctor) formErrors.doctor = 'Doctor is required';
        if (!selectedSlot) formErrors.slot = 'Slot is required';
        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };

    return (
        <>
            <InactivityTimer />
            <div className="page-container flex flex-col">
                <div className="form-container flex-grow overflow-auto overflow-x-hidden">
                    <StepOne />
                    <div className='px-4 sm:px-8 lg:px-14 mt-6'>
                        <form onSubmit={handleSubmit}>

                            <div className="flex flex-col space-y-2 mt-6">
                                <label className="text-base sm:text-lg font-semibold">
                                    Appointment Date <span className="text-red-500">*</span>
                                </label>

                                <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
                                    <div className="flex items-center space-x-3 sm:space-x-4">
                                        <button
                                            type="button"
                                            className={`px-3 py-2 bg-white rounded ${selectedDate <= tomorrow ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-400'}`}
                                            onClick={handlePrevDate}
                                            disabled={selectedDate <= tomorrow}
                                        >
                                            <img src={FiChevronLeftImg} alt='left' className="w-5 h-5" />
                                        </button>

                                        <div className="text-sm sm:text-[16px] font-semibold bg-[#0FA968] text-white px-3 py-2 rounded whitespace-nowrap">
                                            {isToday ? 'Today' : formatDate(selectedDate)}
                                        </div>

                                        <button
                                            type="button"
                                            className="px-3 py-2 bg-white rounded hover:bg-gray-400"
                                            onClick={handleNextDate}
                                        >
                                            <img src={FiChevronRightImg} alt='right' className="w-5 h-5" />
                                        </button>
                                    </div>

                                    <div className="relative flex w-full sm:w-auto">
                                        <div className="absolute inset-y-0 left-0 flex items-center pl-3.5">
                                            <img src={FiSearch} alt='search' className="w-5 h-5 text-gray-500" />
                                        </div>
                                        <input
                                            type="text"
                                            value={searchQuery}
                                            onChange={handleInputChange}
                                            className={`bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full sm:w-[320px] lg:w-[400px] pl-10 p-2 focus:outline-none focus:ring-2 ring-blue-500 focus:ring-gray-600 focus:border-transparent h-10`}
                                            placeholder="Search department"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Department Selection */}
                            {loading ? (
                                <div className='mt-6 text-center'>
                                    <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-[#0FA968]"></div>
                                    <p className="mt-2 text-gray-600">Loading departments...</p>
                                </div>
                            ) : (
                                <div className='mt-6'>
                                    <div className='flex items-center space-x-2 sm:space-x-4'>
                                        <button
                                            type="button"
                                            className="hidden sm:block px-3 py-2 bg-white rounded hover:bg-gray-400 shrink-0"
                                            onClick={() => {
                                                const container = document.getElementById('department-scroll-container');
                                                container.scrollBy({ left: -300, behavior: 'smooth' });
                                            }}
                                        >
                                            <img src={FiChevronLeftImg} alt='left' className="w-5 h-5" />
                                        </button>

                                        <div id="department-scroll-container" className='overflow-x-auto hide-scrollbar-department flex-grow'>
                                            <div className='flex space-x-5 max-content-width'>
                                                {filteredDepartments.map((department) => (
                                                    <label key={department.departmentId || department.deptId} className='flex items-center cursor-pointer'>
                                                        <input
                                                            type='radio'
                                                            name='department'
                                                            value={department.departmentId}
                                                            checked={selectedDepartment?.departmentId === department.departmentId}
                                                            onChange={() => handleDepartmentChange(department)}
                                                            className='hidden'
                                                        />
                                                        <span
                                                            className={`px-3 py-2 bg-white rounded-2xl text-[#27272A] whitespace-nowrap ${selectedDepartment?.departmentId === department.departmentId
                                                                ? 'bg-[#DAFEEF] text-[#0FA968] border border-[#0FA968]'
                                                                : 'hover:bg-[#DAFEEF] hover:text-[#0FA968] hover:border hover:border-1 hover:border-[#0FA968]'
                                                                }`}
                                                        >
                                                            {department.departmentName || department.deptName}
                                                        </span>
                                                    </label>
                                                ))}
                                            </div>
                                        </div>

                                        <button
                                            type="button"
                                            className="hidden sm:block px-3 py-2 bg-white rounded hover:bg-gray-400 shrink-0"
                                            onClick={() => {
                                                const container = document.getElementById('department-scroll-container');
                                                container.scrollBy({ left: 300, behavior: 'smooth' });
                                            }}
                                        >
                                            <img src={FiChevronRightImg} alt='right' className="w-5 h-5" />
                                        </button>
                                    </div>
                                    {errors.department && <p className="text-red-500 text-sm mt-1">{errors.department}</p>}
                                </div>
                            )}

                            {selectedDepartment && doctorsLoading && (
                                <div className='mt-6 text-center'>
                                    <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-[#0FA968]"></div>
                                    <p className="mt-2 text-gray-600">Loading doctors...</p>
                                </div>
                            )}

                            {selectedDepartment && !doctorsLoading && filteredDoctors.length > 0 && (
                                <div className='mt-6'>
                                    <p className='text-[#0FA968] text-[16px] font-roboto font-semibold mb-3'>SELECT DOCTOR</p>
                                    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4'>
                                        {filteredDoctors.map((doctor, index) => (
                                            <label
                                                key={doctor.empId || doctor.consultantId || doctor.id || index}
                                                className='flex flex-col cursor-pointer'
                                                onClick={() => handleDoctorChange(doctor)}
                                            >
                                                <span
                                                    className={`px-3 py-2 bg-white rounded-lg text-[#27272A] mb-2 ${(selectedDoctor?.empId === doctor.empId)
                                                        ? 'bg-[#DAFEEF] text-[#0FA968] border-2 border-[#0FA968]'
                                                        : 'hover:bg-[#DAFEEF] hover:text-[#0FA968] hover:border hover:border-1 hover:border-[#0FA968] border border-gray-200'
                                                        }`}
                                                >
                                                    {doctor.empName || doctor.consultantName || doctor.name}
                                                    {(doctor.designation || doctor.serviceName) && (
                                                        <p className='text-sm text-gray-600'>
                                                            {doctor.designation || doctor.serviceName}
                                                        </p>
                                                    )}
                                                    <p className='text-sm text-[#0FA968] font-semibold mt-1'>
                                                        Fee: ₹{doctor.totalAmount}
                                                    </p>
                                                </span>
                                            </label>
                                        ))}
                                    </div>
                                    {errors.doctor && <p className="text-red-500 text-sm mt-1">{errors.doctor}</p>}
                                </div>
                            )}

                            {isDoctorSelected && (
                                <>
                                    {slotsLoading ? (
                                        <div className='mt-6 text-center'>
                                            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-[#0FA968]"></div>
                                            <p className="mt-2 text-gray-600">Loading available slots...</p>
                                        </div>
                                    ) : availableSlots.length > 0 ? (
                                        <>
                                            <div className='mt-6'>
                                                <p className='text-[#0FA968] text-base sm:text-[18px] font-roboto font-semibold'>AVAILABLE TIME SLOTS</p>
                                                <div className='mt-2 flex flex-wrap items-center gap-x-4 gap-y-2'>
                                                    <span className='inline-flex items-center'><span className='py-1 px-4 bg-white rounded border border-gray-300'></span><span className="ms-2 text-sm sm:text-[16px]">Available</span></span>
                                                    <span className='inline-flex items-center'><span className='py-1 px-4 bg-[#D9D9DE] rounded'></span><span className="ms-2 text-sm sm:text-[16px]">Booked</span></span>
                                                    <span className='inline-flex items-center'><span className='py-1 px-4 bg-[#0FA968] rounded'></span><span className="ms-2 text-sm sm:text-[16px]">Selected</span></span>
                                                </div>
                                            </div>

                                            {/* Morning Slots */}
                                            {morningSlots.length > 0 && (
                                                <div className='mt-6'>
                                                    <h3 className='text-[#0FA968] text-[16px] font-semibold mb-3'>🌅 Morning (9:00 AM - 12:00 PM)</h3>
                                                    <div className='grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 xl:grid-cols-8 gap-2 sm:gap-4'>
                                                        {morningSlots.map((slot, index) => (
                                                            <label key={index} className='flex flex-col cursor-pointer'>
                                                                <input
                                                                    type='radio'
                                                                    name='slotTime'
                                                                    value={slot.slotTimeStr}
                                                                    checked={selectedSlot === slot.slotTimeStr}
                                                                    onChange={handleSlotChange}
                                                                    className='hidden'
                                                                />
                                                                <span
                                                                    className='text-center px-3 py-2 rounded text-[#27272A] text-[14px] bg-white hover:bg-[#DAFEEF] hover:text-[#0FA968] border border-gray-300'
                                                                    style={selectedSlot === slot.slotTimeStr ? { backgroundColor: '#0FA968', color: 'white', borderColor: '#0FA968' } : {}}
                                                                >
                                                                    {slot.slotTimeStr}
                                                                </span>
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {/* Afternoon Slots */}
                                            {afternoonSlots.length > 0 && (
                                                <div className='mt-6'>
                                                    <h3 className='text-[#0FA968] text-[16px] font-semibold mb-3'>☀️ Afternoon (12:00 PM - 5:00 PM)</h3>
                                                    <div className='grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 xl:grid-cols-8 gap-2 sm:gap-4'>
                                                        {afternoonSlots.map((slot, index) => (
                                                            <label key={index} className='flex flex-col cursor-pointer'>
                                                                <input
                                                                    type='radio'
                                                                    name='slotTime'
                                                                    value={slot.slotTimeStr}
                                                                    checked={selectedSlot === slot.slotTimeStr}
                                                                    onChange={handleSlotChange}
                                                                    className='hidden'
                                                                />
                                                                <span
                                                                    className='text-center px-3 py-2 rounded text-[#27272A] text-[14px] bg-white hover:bg-[#DAFEEF] hover:text-[#0FA968] border border-gray-300'
                                                                    style={selectedSlot === slot.slotTimeStr ? { backgroundColor: '#0FA968', color: 'white', borderColor: '#0FA968' } : {}}
                                                                >
                                                                    {slot.slotTimeStr}
                                                                </span>
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {/* Evening Slots */}
                                            {eveningSlots.length > 0 && (
                                                <div className='mt-6'>
                                                    <h3 className='text-[#0FA968] text-[16px] font-semibold mb-3'>🌙 Evening (5:00 PM - 12:00 AM)</h3>
                                                    <div className='grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 xl:grid-cols-8 gap-2 sm:gap-4'>
                                                        {eveningSlots.map((slot, index) => (
                                                            <label key={index} className='flex flex-col cursor-pointer'>
                                                                <input
                                                                    type='radio'
                                                                    name='slotTime'
                                                                    value={slot.slotTimeStr}
                                                                    checked={selectedSlot === slot.slotTimeStr}
                                                                    onChange={handleSlotChange}
                                                                    className='hidden'
                                                                />
                                                                <span
                                                                    className='text-center px-3 py-2 rounded text-[#27272A] text-[14px] bg-white hover:bg-[#DAFEEF] hover:text-[#0FA968] border border-gray-300'
                                                                    style={selectedSlot === slot.slotTimeStr ? { backgroundColor: '#0FA968', color: 'white', borderColor: '#0FA968' } : {}}
                                                                >
                                                                    {slot.slotTimeStr}
                                                                </span>
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {/* Night Slots — BUG 4 FIX: midnight–05:59 shown separately */}
                                            {nightSlots.length > 0 && (
                                                <div className='mt-6'>
                                                    <h3 className='text-[#0FA968] text-[16px] font-semibold mb-3'>🌃 Night (12:00 AM - 6:00 AM)</h3>
                                                    <div className='grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 xl:grid-cols-8 gap-2 sm:gap-4'>
                                                        {nightSlots.map((slot, index) => (
                                                            <label key={index} className='flex flex-col cursor-pointer'>
                                                                <input
                                                                    type='radio'
                                                                    name='slotTime'
                                                                    value={slot.slotTimeStr}
                                                                    checked={selectedSlot === slot.slotTimeStr}
                                                                    onChange={handleSlotChange}
                                                                    className='hidden'
                                                                />
                                                                <span
                                                                    className='text-center px-3 py-2 rounded text-[#27272A] text-[14px] bg-white hover:bg-[#DAFEEF] hover:text-[#0FA968] border border-gray-300'
                                                                    style={selectedSlot === slot.slotTimeStr ? { backgroundColor: '#0FA968', color: 'white', borderColor: '#0FA968' } : {}}
                                                                >
                                                                    {slot.slotTimeStr}
                                                                </span>
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {errors.slot && <p className="text-red-500 text-sm mt-2">{errors.slot}</p>}
                                        </>
                                    ) : (
                                        <div className='mt-6 text-center'>
                                            <p className="text-gray-600">No available slots for selected doctor on this date.</p>
                                        </div>
                                    )}
                                </>
                            )}

                            <div className='flex flex-col-reverse sm:flex-row justify-center items-stretch sm:items-center mt-6 mb-6 gap-3 sm:gap-4'>
                                <Link
                                    to="/dashboard"
                                    type="button"
                                    className="px-4 py-2.5 bg-[#EFFEF7] text-[#0FA968] font-semibold rounded-lg shadow hover:bg-[#138F5E] hover:text-white transition duration-200 border border-[#0FA968] text-center"
                                >
                                    Cancel
                                </Link>
                                <button
                                    type="submit"
                                    disabled={isSubmitting || slotsLoading || doctorsLoading}
                                    className="px-6 py-2.5 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200 text-base sm:text-[18px] disabled:opacity-60 disabled:cursor-not-allowed"
                                >
                                    {isSubmitting ? (
                                        <span className="inline-flex items-center justify-center gap-2">
                                            <span className="inline-block animate-spin rounded-full h-5 w-5 border-b-2 border-white"></span>
                                            Please wait...
                                        </span>
                                    ) : selectedDoctor?.totalAmount && parseFloat(selectedDoctor.totalAmount) > 0 ? (
                                        <>Pay ₹{selectedDoctor.totalAmount} & Book Appointment</>
                                    ) : selectedDoctor?.totalAmount === 0 || selectedDoctor?.totalAmount === '0' ? (
                                        <>Book Free Appointment</>
                                    ) : (
                                        <>Book Appointment</>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {isSubmitting && (
                <div className="fixed inset-0 z-50 flex flex-col justify-center items-center bg-black bg-opacity-50 px-4 text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-white"></div>
                    <p className="mt-4 text-white font-semibold">Redirecting to payment gateway...</p>
                </div>
            )}

            {/* IP Status Dialog */}
            {showIPStatusDialog && (
                <div className="fixed inset-0 z-50 flex justify-center items-center w-full h-full bg-black bg-opacity-50">
                    <div className="relative p-8 w-full max-w-md bg-white rounded-2xl shadow-2xl">
                        <div className="text-center">
                            <div className="w-20 h-20 mx-auto mb-4 bg-red-100 rounded-full flex items-center justify-center">
                                <svg className="w-12 h-12 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                </svg>
                            </div>
                            <h3 className="text-2xl font-bold text-[#22292A] mb-4">
                                Cannot Book Appointment
                            </h3>
                            <p className="text-gray-600 text-lg leading-relaxed mb-4">
                                You can't book an appointment because your current patient visit status is <strong className="text-red-600">{patientData?.patVisitStatus}</strong> (In-Patient) and your visit status is <strong className="text-red-600">{patientData?.visitStatus}</strong>.
                            </p>
                            <div className="bg-red-50 rounded-lg p-4 mb-6">
                                <p className="text-sm text-gray-700">
                                    <strong>Patient Visit Status:</strong> {patientData?.patVisitStatus}<br />
                                    <strong>Visit Status:</strong> {patientData?.visitStatus}<br />
                                    <strong>Last Visit:</strong> {patientData?.lastVisitNo}<br />
                                    <strong>Visit Date:</strong> {patientData?.visitDate}
                                </p>
                            </div>

                            <div className="flex gap-4">
                                <button
                                    onClick={() => navigate('/dashboard')}
                                    className="flex-1 bg-[#0FA968] text-white py-3 px-6 rounded-lg font-semibold hover:bg-[#138F5E] transition duration-200"
                                >
                                    Go to Dashboard
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default BookAppointment;